import { clearUserTour } from "@/features/tour/utils";
import { Input } from "@repo/skapa";
import { trashCanIcon } from "@repo/skapa";
import { Button } from "@repo/skapa";
import { DEFAULT_LOCALE, getLanguageAndLocaleFromUrl } from "@repo/translation";
import { useSettings } from "@repo/ui";
import { SectionContainer } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";
import InnerHTML from "dangerously-set-html-content";
import { useEffect, useState } from "react";

const FragmentItem = ({ setRendered, getFragment }: any) => {
  const [html, setHtml] = useState<string | undefined>(undefined);
  useEffect(() => {
    getFragment().then((res: any) => {
      setHtml(res);
      setRendered(true);
    });
  }, [getFragment, setRendered]);

  if (!html) {
    return null;
  }

  return <InnerHTML html={html} />;
};

const getUrl = () => {
  const locale = getLanguageAndLocaleFromUrl();
  const { country, language } = locale ?? DEFAULT_LOCALE;

  return `${
    import.meta.env.VITE__LOCALE_PREFIX
      ? `${import.meta.env.VITE__LOCALE_PREFIX}/`
      : "/"
  }${country}/${language}/saleslead/associate-project.html`;
};

const getSalesLeadOrderFragment = async () => {
  const fullUrl = getUrl();
  const result = await fetch(fullUrl);
  const res = await result.text();
  return res;
};

export const PlaygroundPage = () => {
  const { feature_flags } = useSettings();

  if (!feature_flags?.playground) {
    return <div>Nothing to see here.</div>;
  }

  return (
    <SectionContainer>
      <SectionContainer>
        <Input
          id="order-number"
          type="text"
          label="Order number"
          onChange={(e) => {
            if (window.salja?.salesLead) {
              window.salja.salesLead.orderNumber = e.target.value;
            }
            trackAnalytics("change_order_number");
          }}
        />
        <Button
          type="secondary"
          text="Associate order"
          onClick={() =>
            window?.salja?.salesLead?.orderNumber &&
            window?.salja?.salesLead?.openAssociateProject?.(
              window.salja.salesLead.orderNumber
            )
          }
        />

        <FragmentItem getFragment={() => getSalesLeadOrderFragment()} />
      </SectionContainer>
      <SectionContainer>
        <Button
          iconOnly
          ssrIcon={trashCanIcon}
          size="small"
          type="secondary"
          onClick={() => {
            clearUserTour();
            trackAnalytics("clear_all_tours");
          }}
        >
          Clear all tours
        </Button>
      </SectionContainer>
    </SectionContainer>
  );
};
